(() => {
  const getVisibleCount = () => {
    const state = window.FlyAndBagPickup?.getState?.();
    const cart = state?.cart;
    if (!cart) return null;

    const feeQuantity = (state?.a?.fees || []).reduce(
      (total, item) => total + Number(item?.quantity || 0),
      0
    );

    return Math.max(0, Number(cart.item_count || 0) - feeQuantity);
  };

  const syncVisibleCount = () => {
    const count = getVisibleCount();
    if (count === null) return;

    document.querySelectorAll('cart-icon').forEach((icon) => {
      if (typeof icon.renderCartBubble === 'function') {
        icon.renderCartBubble(count, false);
        return;
      }

      const bubble = icon.querySelector('[ref="cartBubble"]');
      const countElement = icon.querySelector('[ref="cartBubbleCount"]');
      if (countElement) countElement.textContent = String(count);
      bubble?.classList.toggle('visually-hidden', count === 0);
      countElement?.classList.toggle('hidden', count === 0);
      icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });

    document.querySelectorAll('#cart-drawer .theme-drawer__badge').forEach((badge) => {
      badge.textContent = String(count);
      badge.classList.toggle('visually-hidden', count === 0);
    });

    document.querySelectorAll('[ref="cartItemCount"], [data-cart-count]').forEach((element) => {
      element.textContent = String(count);
    });

    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({ value: String(count), timestamp: Date.now() })
      );
    } catch {}
  };

  const refresh = () => {
    window.FlyAndBagPickup?.render?.();
    requestAnimationFrame(syncVisibleCount);
  };

  document.addEventListener('flyandbag:pickup-ready', refresh);
  document.addEventListener('theme-drawer:open', () => {
    window.FlyAndBagPickup?.refresh?.();
    refresh();
  });
  document.addEventListener('cart:lines:update', (event) => {
    const afterUpdate = () => {
      window.FlyAndBagPickup?.refresh?.();
      window.setTimeout(syncVisibleCount, 30);
    };

    if (event?.promise?.finally) event.promise.finally(afterUpdate);
    else afterUpdate();
  });

  window.addEventListener('pageshow', () => {
    window.FlyAndBagPickup?.refresh?.();
    refresh();
  });

  customElements.whenDefined('cart-icon').then(syncVisibleCount);
  window.FlyAndBagPickupCountFix = syncVisibleCount;

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', refresh, { once: true })
    : refresh();
})();

(() => {
  const feeProductHandle = 'frais-service-pickup';
  const feeProductTitle = 'frais de gestion de commande';
  const englishHeading = 'you may also like';
  const frenchHeading = 'Vous aimerez aussi';
  const recommendationLimit = 10;

  const normalize = (value) =>
    String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase('fr-FR');

  const isFeeCard = (card) => {
    if (card.querySelector(`a[href*="/products/${feeProductHandle}"]`)) return true;

    const productLinks = card.querySelectorAll('a[href*="/products/"]');
    for (const link of productLinks) {
      if (normalize(link.textContent) === feeProductTitle) return true;
    }

    return normalize(card.textContent).includes(feeProductTitle);
  };

  const expandRecommendationLimit = (recommendation) => {
    if (recommendation.dataset.recommendationsPerformed === 'true') return;

    const currentUrl = recommendation.dataset.url || '';
    if (!currentUrl) return;

    const nextUrl = /([?&]limit=)\d+/.test(currentUrl)
      ? currentUrl.replace(/([?&]limit=)\d+/, (_, prefix) => `${prefix}${recommendationLimit}`)
      : `${currentUrl}${currentUrl.includes('?') ? '&' : '?'}limit=${recommendationLimit}`;

    if (nextUrl !== currentUrl) recommendation.dataset.url = nextUrl;
  };

  const cleanRecommendationBlock = (recommendation) => {
    expandRecommendationLimit(recommendation);

    recommendation.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
      if (normalize(heading.textContent) === englishHeading) {
        heading.textContent = frenchHeading;
      }
    });

    recommendation.querySelectorAll('.resource-list__item').forEach((card) => {
      if (isFeeCard(card)) card.remove();
    });

    recommendation.querySelectorAll('.resource-list').forEach((list) => {
      const visibleItems = list.querySelectorAll('.resource-list__item').length;
      list.dataset.hasRecommendations = visibleItems > 0 ? 'true' : 'true';
    });
  };

  const applyFix = () => {
    document.querySelectorAll('product-recommendations').forEach(cleanRecommendationBlock);
  };

  let frameId = 0;
  const queueFix = () => {
    if (frameId) return;
    frameId = requestAnimationFrame(() => {
      frameId = 0;
      applyFix();
    });
  };

  const observer = new MutationObserver(queueFix);

  const start = () => {
    applyFix();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();

(() => {
  const catalogPath = '/collections/all';
  const shopPath = '/collections/boutique';

  const pointsToCatalog = (link) => {
    try {
      const url = new URL(link.getAttribute('href') || '', window.location.origin);
      return url.origin === window.location.origin && url.pathname.replace(/\/+$/, '') === catalogPath;
    } catch {
      return false;
    }
  };

  const fixEmptyCartLinks = (root = document) => {
    root.querySelectorAll?.('a.cart-items__empty-button').forEach((link) => {
      if (pointsToCatalog(link)) link.setAttribute('href', shopPath);
    });
  };

  let frameId = 0;
  const queueFix = () => {
    if (frameId) return;
    frameId = requestAnimationFrame(() => {
      frameId = 0;
      fixEmptyCartLinks();
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a.cart-items__empty-button');
    if (!link || !pointsToCatalog(link)) return;

    event.preventDefault();
    window.location.assign(shopPath);
  });

  const start = () => {
    fixEmptyCartLinks();
    new MutationObserver(queueFix).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
